import { createSlice } from '@reduxjs/toolkit'
import { itemStatus } from '@/utils/parameter'
export const scanRecordSlice = createSlice({
  name: 'scanRecord',
  initialState: {
    value: [],
  },
  reducers: {
    resetScanRecord: state => {
      state.value = []
    },
    updateScanRecord: (state, action) => { 
      state.value = action.payload 
    },
    resetToImportRecord: state => {
      state.value = state.value.map((record, index) => {
        if (index !== 0) {
          record[0] = itemStatus.NOT_CHECKED
          record[1] = ""
          record[record.length - 1] = ""
        }
        return record
      })
    }
  }
})

// Action creators are generated for each case reducer function
export const { 
  resetScanRecord, 
  updateScanRecord, 
  resetToImportRecord,
} = scanRecordSlice.actions
// reducer 要放入 store
export default scanRecordSlice.reducer